'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');

var rightRailTransitionDuration = constants.RightRailCssVars.rightRailTransitionDuration,
    rightRailTransitionEasing = constants.RightRailCssVars.rightRailTransitionEasing,
    rightRailTransitionDelay = constants.RightRailCssVars.rightRailTransitionDelay;
var createRightRailCssTransition = function createRightRailCssTransition(propertyNames) {
  return (Array.isArray(propertyNames) ? propertyNames : [propertyNames]).map(function (propertyName) {
    return "".concat(propertyName, " var( ").concat(rightRailTransitionDuration, ", 0ms ) var( ").concat(rightRailTransitionEasing, ", linear ) var( ").concat(rightRailTransitionDelay, ", 0ms )");
  }).join(', ');
};

exports.createRightRailCssTransition = createRightRailCssTransition;
